import { render } from "./InventoryFilters.vue?vue&type=template&id=7b6a0b7e"
import script from "./InventoryFilters.vue?vue&type=script&lang=js"
export * from "./InventoryFilters.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__